<template>
  <div class="banner-container">
    <img :src="bannerData" />
  </div>
</template>

<script>
import service from "../../service/index";
import config from "../../config/dev";
export default {
  name: "JKJYBANNER",
  props: {},
  data() {
    return {
      bannerData: "",
    };
  },
  created() {
    this.getBannerList();
  },
  methods: {
    getBannerList() {
      let parmes = {
        location: "健康教育",
      };
      service.getOtherList(parmes, (res) => {
        this.bannerData =
          config.url +
          "/file/downloadFile/" +
          res.content[0].img +
          "?isDownload=true";
      });
    },
  },
  mounted() {},
  watch: {},
  destroyed() {},
};
</script>
  
<style scoped>
</style>
  

   